  /*============================================================================
  Keap Custom JS
  Copyright 2018 Keap Co.
  Author Stephen Tracy

==============================================================================*/
/*============================================================================
# Fade out loader gif
==============================================================================*/

setTimeout(function(){ 
$(".loader2").fadeOut("medium"); }, 3000);


// $(window).load(function() {
//   $(".loader").fadeOut("medium");
// })

$(document).ready(function() {
    $(".loader").fadeOut("medium");
  });

// $(window).on('load', function (e) {
//   $(".loader").fadeOut("medium");
// });




/*============================================================================
# Black Logo
==============================================================================*/
// var height = $(window).height();
// $(window).scroll(function(){
//     if($(this).scrollTop() > 0)
//     {  
//     	$('.header_logo').addClass("logo-black", 1500) 
//        $('.medium-down--show .header_logo').addClass("logo-black", 1500)
//        // $('.menu-icon').addClass("logo-black", 1500)
//     } else {
//     	$('.header_logo').removeClass("logo-black", 1500) 
//        $('.medium-down--show  .header_logo').removeClass("logo-black", 1500);
//        $(' .menu-icon').removeClass("logo-black", 1500);
//     }
// });


/*============================================================================
# Background For Nav
==============================================================================*/


$(".btn--menu").mouseenter(function(){
  $(".btn--menu").addClass('hover');
}
);

$(".btn--menu").mouseleave(function(){
  $(".btn--menu").removeClass('hover');
}
);


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
        return c.substring(name.length,c.length);
    }
  }
  return "";
}

let productId = $('#AddToCartForm').data('productid');
let cookieKey = `prodlock__${productId}`;
let prodlockButton = $('.prodlock__button');
if (getCookie(cookieKey) === prodlockButton.data('pass')) {
  $('.prodlock').addClass('prodlock--unlocked-saved');
}

prodlockButton.click(function(){
  let pass = $('.prodlock__input').val();
  let correctPass = $(this).data('pass');
  if (pass === correctPass) {
    $('.prodlock').addClass('prodlock--unlocked');
    setCookie(cookieKey, $(this).data('pass'), 365);
  } else {
    $('.prodlock__input').addClass('prodlock__input--error');
    $('.prodlock__input-error').addClass('prodlock__input-error--visible');
    $('.prodlock__input').val('');
  }
});


const getDefaultVariantInventory = async (id) => {
  const graphQLQuery = `
    query {
      product(id: "gid://shopify/Product/${id}") {
        variants(first: 100) {
          edges {
              node {
                id
                quantityAvailable
              }
          }
        }
      }
    }
  `;

  let inventory = await fetch('https://elfish.myshopify.com/api/2023-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': '2ca837521f3a7c118baa90a634db7e1a'
    },
    body: graphQLQuery
  })
  let inventoryJson = await inventory.json();
  return inventoryJson.data.product.variants.edges;
} 

setTimeout(async () => {
  if (!window.variantBundles) return
  let variantBundlesKeys = Object.keys(window.variantBundles);
  if (productId  && variantBundlesKeys.length > 0) {
    console.log('test');
    setInterval(async () => {
      let inventory = await getDefaultVariantInventory(productId);
      let inventoryMainItems = inventory.filter((item) => {
        return window.mainVariants.hasOwnProperty(item.node.id.replace('gid://shopify/ProductVariant/', ''));
      }).map(item => {
        return {
          id: item.node.id.replace('gid://shopify/ProductVariant/', ''),
          quantityAvailable: item.node.quantityAvailable
        }
      });
      inventoryMainItems.map(item => {
        window.mainVariants[item.id].inventory_quantity = item.quantityAvailable;
      });
      const urlParams = new URLSearchParams(window.location.search);
      let variant = urlParams.get('variant');
      if (!variant) {
        variant = window.productSelector.product.variants[0].id;
      }
      window.productSelector.selectVariant(variant);
    }, 5000);
  }
}, 5000);

// timeout and interval should be 5 seconds